<template>
  <div
    v-if="media"
    class="c-media-display"
  >
    <div
      class="l-flex l-flex--align-start l-flex--justify-start"
      role="contentinfo"
    >
      <nav
        v-if="media.length > 1"
        class="c-media-display__menu l-flex l-flex--column"
        role="menu"
      >
        <template v-for="(asset, index) in media">
          <button
            v-if="index < 6"
            :key="index"
            role="menuitem"
            class="c-media-display__menu-item l-flex"
            :class="forceMobile ? 'u-hidden' : 'u-hidden-mobile'"
            @click="displayMedia = asset"
          >
            <img
              v-if="asset.type == 'image'"
              class="c-media-display__menu-media"
              :src="asset.thumbnailSrc"
              :alt="asset.alt || 'Click to see ' + asset.type + ' ' + (index+1)"
            >
            <div
              v-else-if="asset.type == 'video'"
              class="c-media-display__menu-video-container"
              :aria-label="asset.alt || asset.type"
            >
              <img
                class="c-media-display__menu-media"
                :src="asset.thumbnailSrc"
                :alt="asset.alt || 'Click to see ' + asset.type + ' ' + (index+1)"
              >
              <img
                class="c-media-display__menu-video-icon"
                src="~@/assets/icons/play.svg"
                alt="Play"
                aria-label="video."
              >
            </div>
          </button>
        </template>
      </nav>
      <div class="l-flex__item">
        <Badge
          v-if="clearance"
          background-class="u-background-color-primary"
          class="u-z-index-1"
        >
          Clearance
        </Badge>
        <div
          v-if="displayMedia"
          class="l-flex u-margin-bottom-medium"
          :class="displayClass"
        >
          <img
            v-if="displayMedia.type == 'image'"
            class="c-media-display__display-media"
            :src="displayMedia.src"
            :alt="displayMedia.alt || 'Display image'"
          >
          <vid
            v-else-if="displayMedia.type == 'video'"
            v-bind="displayMedia"
          />
          <p
            v-if="mediaTitle && displayMedia.type != 'video'"
            class="c-media-display__display-title"
          >
            {{ mediaTitle }}
          </p>
        </div>
        <div
          v-if="media.length > 1"
          class="c-media-display__dots-flex l-flex l-flex--column"
        >
          <nav
            class="c-media-display__menu l-flex"
            role="menubar"
          >
            <template v-for="(asset, index) in media">
              <button
                v-if="index < 6"
                :key="index"
                role="menuitem"
                class="c-media-display__menu-item l-flex"
                :class="forceMobile ? '' : 'u-hidden-desktop u-hidden-desktop--flex'"
                @click="displayMedia = asset"
              >
                <img
                  v-if="asset.type == 'image'"
                  class="c-media-display__menu-media"
                  :src="asset.thumbnailSrc"
                  :alt="asset.alt || 'Click to see ' + asset.type + ' ' + (index+1)"
                >
                <div
                  v-else-if="asset.type == 'video'"
                  class="c-media-display__menu-video-container"
                >
                  <img
                    class="c-media-display__menu-media"
                    :src="asset.thumbnailSrc"
                    :alt="asset.alt || 'Click to see ' + asset.type + ' ' + (index+1)"
                  >
                  <img
                    class="c-media-display__menu-video-icon"
                    src="~@/assets/icons/play.svg"
                    alt="Play"
                  >
                </div>
              </button>
            </template>
          </nav>
          <div
            v-if="media.length > 1"
            class="l-flex"
          >
            <template v-for="(asset, index) in media">
              <div
                v-if="index < 6"
                :key="index"
                :class="[ asset == displayMedia ? 'c-media-display__dots--active' : '', 'c-media-display__dots']"
                @click="displayMedia = asset"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vid from "../video/Vid";
import Badge from "../badge/Badge";

export default {
  name: "MediaDisplay",
  components: {
    Vid,
    Badge
  },
  props: {
    media: {
      type: Array,
      default: null
    },
    mediaTitle: {
      type: String,
      default: null
    },
    forceMobile: {
      type: Boolean,
      default: false
    },
    availableForSale: {
      type: Boolean,
      default: true
    },
    clearance: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayMedia: {}
    }
  },
  computed: {
    displayClass() {
      let results = 'c-media-display__display'
      if (this.availableForSale == false) {
        results +=  ' c-media-display__display--oos'
      }
      if (this.forceMobile) {
        results +=  ' c-media-display__display--cart'
      }
      return results;
    },
  },
  watch: {
    media() {
      if (this.media) {
        this.displayMedia = this.media[0];
      }
    }
  },
  created() {
    if (this.media) {
      this.displayMedia = this.media[0];
    }
  }
}
</script>

<style lang="scss" scoped>
.c-media-display {
  &__menu-item {
    width: rem(55px);
    height: rem(55px);
    margin-right: rem(15px);
    padding: rem(5px);
    margin-bottom: rem(10px);

    @include themify($themes) {
      background: themed('background', 'base');
      border: $border themed('foreground', 'section-border');
    }

    &:hover {
      cursor: pointer;
    }
  }

  &__menu-media {
    max-width: 100%;
  }

  &__menu-video-container {
    position: relative;
    width: rem(43px);
    height: rem(43px);
  }

  &__menu-video-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: rem(33px);
    height: rem(33px);
  }

  &__display {
    position: relative;
    width: rem(565px);
    height: rem(565px);
    max-width: 100%;

    @include  respond(phone) {
      width: 100%;
    }

    @include themify($themes) {
      background-color: themed('background', 'xx-light')
    }

    &--cart {
      width: rem(300px);
      height: rem(300px);
    }

    &--oos {
      &:before {
        content: '';
        z-index: 5;
        width: 100%;
        height: 100%;
        position: absolute;
        @include themify($themes) {
          background-color: themed('background', 'light');
          opacity: .5;
        }
      }
      &:after {
        content: 'this size is out of stock';
        font-size: rem(30px);
        line-height: rem(38px);
        letter-spacing: rem(2px);
        font-weight: $font-weight-medium;
        text-transform: uppercase;
        @include themify($themes) {
          color: themed('background', 'light');
        }
        text-align: center;
        z-index: 6;
        width: 100%;
        position: absolute;
      }
    }
  }

  &__display-media {
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }

  &__display-title {
    position: absolute;
    bottom: 10px;
    left: 10px;
    @include themify($themes) {
      color: themed('foreground', 'x-light-text')
    }
  }

  &__dots-flex {
    @include respond(tab-land) {
      justify-content: flex-start;
    }
  }

  &__dots {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    &:not(:last-child) {
      margin-right: rem(10px);
    }
    @include themify($themes) {
      border: $border themed('foreground', 'select');
    }
    &--active {
      @include themify($themes) {
        background-color: themed('foreground', 'accent-selected');
        border: $border themed('foreground', 'accent-selected');
      }
    }

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
